var map = {
	"./icon_bandaoti_default.png": "f095",
	"./icon_jiaoyu_default.png": "bf04",
	"./icon_shangye_default.png": "225d",
	"./icon_xinnengyuan_default.png": "7cd7",
	"./icon_yancao_default.png": "d6fd",
	"./icon_yiyao_default.png": "6c36",
	"./icon_zhinengzhizao_default.png": "4f5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ce80";